var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.37484 15.5832H10.6248C14.1665 15.5832 15.5832 14.1665 15.5832 10.6248V6.37484C15.5832 2.83317 14.1665 1.4165 10.6248 1.4165H6.37484C2.83317 1.4165 1.4165 2.83317 1.4165 6.37484V10.6248C1.4165 14.1665 2.83317 15.5832 6.37484 15.5832Z",
    stroke: "#2AA7E0",
    strokeWidth: 1.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3957 8.49984C12.3957 10.6532 10.6532 12.3957 8.49984 12.3957C6.3465 12.3957 5.03608 10.2282 5.03608 10.2282M5.03608 10.2282H6.79275M5.03608 10.2282V12.1761M4.604 8.49984C4.604 6.3465 6.33234 4.604 8.49984 4.604C11.0994 4.604 12.3957 6.7715 12.3957 6.7715M12.3957 6.7715V4.82359M12.3957 6.7715H10.6673",
    stroke: "#2AA7E0",
    strokeWidth: 1.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.cc29e8961048e840727dc1ffa02548be.svg";
export { ForwardRef as ReactComponent };